'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-list.routes';

export class DocumentListComponent {
  /*@ngInject*/
  constructor(Auth, DocumentService, DTOptionsBuilder, dialogs, $stateParams, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.DocumentService = DocumentService;
    this.data = [];

    this.type = $stateParams.type || 'list';
    this.filterCat = '';

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.documentPageCategories = documentConfig.getPageCategories();
    this.documentPageRoleRestriction = documentConfig.getPageRoleRestriction();
    this.navStyle = documentConfig.getNavStyle();

    this.dialogs = dialogs;

    this.pageTitle = documentConfig.getPageTitleByCategory(this.type);
    this.categories = documentConfig.getTypesByCategory(this.type);

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('responsive', true)
      .withOption('order', [0, 'desc'])
      .withBootstrap();

    Auth.isAdmin(isAdmin => {
      this.isAdmin = isAdmin;

      let queryFn = (this.public) ? this.DocumentService.queryPublic : this.DocumentService.query;

      if (this.documentPageRoleRestriction[this.type]) {

        if (this.public) {
          this.noPermission = true;
          return;
        }

        let user = Auth.getCurrentUserSync();

        let roleRestriction = this.documentPageRoleRestriction[this.type];
        let isArray = Array.isArray(roleRestriction);

        if (
              (isArray && !roleRestriction.some(role => user.role.includes(role)))
          || (!isArray && !user.role.includes(roleRestriction))) {
          this.noPermission = true;
          return;
        }
      }

      queryFn((data) => {
        this.data = data.filter(doc => {
          return this.categories.indexOf(doc.type) != -1;
        });

        this.filteredData = this.data;
      }, err => {
        console.log("Could not retrieve documents.")
      })
    });

  }

  getCount(cat) {
    return this.data.reduce((acc, obj) => {
      return acc + (obj.type === cat);
    }, 0);
  }

  setFilter(cat) {
    this.filterCat = cat;
    if (!this.filterCat) {
      this.filteredData = this.data;
    } else {
      this.filteredData = this.data.filter(doc => doc.type == this.filterCat);
    }
  }

  getStoragePath(docId, storageId) {
    if (this.public) {
      return "/api/storage/public/"+storageId+"/ctx/"+this.getContext(docId);
    }

    return "/api/storage/"+storageId;
  }

  getContext(docId) {
    return btoa("document:"+docId);
  }

  delete(doc) {
    var that = this;

    var docText = "<br/><br/><b>" + doc.title + "</b><br/><p>" + doc.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Document?", "Do you really want to delete this document?" + docText);
    dlg.result.then(() => {
      // OK delete it
      that.DocumentService.delete({id: doc._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== doc._id;
          });
          that.setFilter(that.filterCat);

          //that.data = that.data.filter(obj => obj._id !== doc._id);
        },
        err => {
          alert("Could not delete document");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.documentList', [uiRouter])
  .config(routes)
  .component('documentList', {
    template: require('./document-list.html'),
    controller: DocumentListComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/list/document-list.component.js